import React, { useContext, useEffect, useRef, useState } from "react";
import { WebsocketContext } from "../../store/WebSocketContext";

export default function NewAudioPlayer() {
  const [ready, val] = useContext(WebsocketContext);
  const [userInteracted, setUserInteracted] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if (val && audioRef.current) {
      audioRef.current.src = val;
      audioRef.current.play().catch((error) => {
        console.error("Error playing audio:", error);
      });
    }
  }, [val]);

  const handleUserInteraction = () => {
    setUserInteracted(true);
    if (audioRef.current) {
      audioRef.current.play().catch((error) => {
        console.error("Error playing audio:", error);
      });
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-900 text-white">
      <h1 className="text-4xl mb-8">New Donation Audio Player</h1>
      {!userInteracted ? (
        <button
          onClick={handleUserInteraction}
          className="px-4 py-2 bg-blue-500 text-white rounded"
        >
          Click to enable audio
        </button>
      ) : (
        <>
          <p className="text-sm mb-4">
            Connection status: {ready ? "Connected" : "Disconnected"}
          </p>
          {ready ? (
            val ? (
              <div className="w-full max-w-md">
                <audio ref={audioRef} controls className="w-full">
                  Your browser does not support the audio element.
                </audio>
              </div>
            ) : (
              <p className="text-xl">Waiting for new donations...</p>
            )
          ) : (
            <p className="text-xl text-red-500">
              WebSocket disconnected, attempting to reconnect...
            </p>
          )}
        </>
      )}
    </div>
  );
}
